import React from 'react'
import './fields.css'

const Labs = () => {
    return (
        <div>
            zenith is here with the fields
        </div>
    )
}

export default Labs